
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/features/travel-mode",
      function () {
        return require("private-next-pages/[lang]/features/travel-mode.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/features/travel-mode"])
      });
    }
  